import {equals, pipe, toUpper} from 'ramda'

export const AIRBNB_PROVIDER_CODE = 'BNB'

const isAirbnbProvider = equals<string>(AIRBNB_PROVIDER_CODE)

/**
 * Determines if Airbnb is the provider for the given offer.
 * @param offer - The offer you are checking
 * @param offer.intermediaryProvider - The intermediary provider code
 * @param offer.proxyProviderCode - The proxy provider code
 * @returns Whether Airbnb is the provider for the given offer
 */
// Checks intermediaryProvider first, falling back to proxyProviderCode.
export const isAirbnbOffer = (offer?: {
  intermediaryProvider?: string
  proxyProviderCode?: string
}): boolean => {
  const providerCode =
    offer?.intermediaryProvider ?? offer?.proxyProviderCode ?? ''
  return pipe(toUpper, isAirbnbProvider)(providerCode)
}
